import Grid2 from '@mui/material/Unstable_Grid2';
import React, { FC } from 'react';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../context/ApplicationContext';
import { FORM_FIELDS_TYPES, PLATZHALTER_TEXT } from '../../../../../../lib/constants/constant';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';
// import { Box } from "devextreme-react";
// import { useMediaQuery } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
import { Box, Divider, Stack, Tooltip, Typography } from '@mui/material';
import { concat } from 'lodash';
import AntragSchema from '../../../../../../lib/paths/antrag_FULL_Paths.json';
import { FormStrucItem } from '../../../../../../lib/types/types';
import { NonRequired, Required } from '../../../../../../lib/validation/ValidationTypes';
const P = AntragSchema.attributes;

const Bewerbungsdaten: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	return (
		<>
			<ApplicationHeading title='Bewerbungsdaten' description={PLATZHALTER_TEXT} />
			<Grid2 container direction={'column'}>
				<Grid2 xs={12} md={6}>
					<CreateForm
						formStruc={formStrucAllgemeinBeschreibung()}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={readOnly}
					/>
				</Grid2>
				<Grid2 xs={12} sx={{ mt: '2rem' }}>
					<Typography variant='body1' sx={{ mb: '-.8rem' }}>
						Bisherige Veroeffentlichungen
						<Tooltip title='Das Hochladen von Bisherige Veroeffentlichungen ist optional.'>
							<HelpIcon sx={{ ml: 1, color: 'primary.main', fontSize: '1.25rem' }} />
						</Tooltip>
					</Typography>
					<CreateForm
						formStruc={formStrucVeroeffentlichungen()}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={readOnly}
					/>
				</Grid2>
			</Grid2>

			<Box sx={{ m: '4rem 0' }}>
				<Stack spacing={5}>
					<Box sx={{ mb: '-2rem' }}>
						<Typography variant='h4'>
							Anlagen
							<Tooltip title='Bitte laden Sie nur Dateien in einem der folgenden Formate hoch: DOCX, PDF, XLSX, ODT, JPG, BMP, PNG, MP3 oder MP4.'>
								<HelpIcon sx={{ ml: 1, color: 'primary.main', fontSize: '1.25rem' }} />
							</Tooltip>
						</Typography>
						<Divider />
					</Box>

					<CreateForm
						formStruc={formStrucPflichtAnlageArbeitsproben()}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={readOnly}
					/>

					<CreateForm
						formStruc={formStrucWeiterArbeitsproben()}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={readOnly}
					/>

					<CreateForm formStruc={formStrucManuskript()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
					<Box sx={{ width: { md: '50%' } }}>
						<CreateForm
							formStruc={formStrucPflichtAnlageExpose()}
							formValues={application}
							updateFormValuesFunc={setApplicationProperty}
							readOnly={readOnly}
						/>
					</Box>
					<CreateForm
						formStruc={formStrucEmpfehlungsschreiben()}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={readOnly}
					/>
					<Box sx={{ width: { md: '50%' } }}>
						<CreateForm
							formStruc={formStrucPflichtAnlageLebenslauf()}
							formValues={application}
							updateFormValuesFunc={setApplicationProperty}
							readOnly={readOnly}
						/>
					</Box>
				</Stack>
			</Box>
		</>
	);
};
export default Bewerbungsdaten;

const formStrucAllgemeinBeschreibung = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [P.Bewerbung_Beginn_Der_Kuenstlerischen_Taetigkeit],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};

const formStrucVeroeffentlichungen = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Bewerbung_Bisherige_Veroeffentlichungen,
					type: FORM_FIELDS_TYPES.editableTable,

					maxLevel: 10,
					validation: [{ validateFunction: NonRequired }],
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};

const formStrucPflichtAnlageArbeitsproben = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Bewerbung_Arbeitsproben,

					validation: [{ validateFunction: Required }],
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};

const formStrucWeiterArbeitsproben = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Bewerbung_Dokumente_Und_Arbeitsproben,
					tooltip: 'Das Hochladen von Dokumente und Arbeitsproben ist optional.',
					maxFiles: 5,
					validation: [{ validateFunction: NonRequired }],
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};

const formStrucManuskript = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Bewerbung_Manuskriptca_20_Seiten,
					// tooltip: 'Das Hochladen von Empfehlungsschreiben ist optional.',
					maxFiles: 5,
					validation: [{ validateFunction: Required }],
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};

const formStrucPflichtAnlageExpose = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [P.Bewerbung_Expose],

			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};
const formStrucEmpfehlungsschreiben = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Bewerbung_Empfehlungsschreiben,
					label: 'Empfehlungsschreiben',
					tooltip: 'Das Hochladen von Empfehlungsschreiben ist optional.',
					maxFiles: 5,
					validation: [{ validateFunction: NonRequired }],
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};

const formStrucPflichtAnlageLebenslauf = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [P.Bewerbung_kuenstlerischer_Lebenslauf],

			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucBewerbungsdaten = () => {
	return concat(
		formStrucVeroeffentlichungen(),
		formStrucAllgemeinBeschreibung(),
		formStrucPflichtAnlageLebenslauf(),
		formStrucPflichtAnlageArbeitsproben(),
		formStrucVeroeffentlichungen(),
		formStrucPflichtAnlageExpose(),
		formStrucEmpfehlungsschreiben(),
		formStrucManuskript(),
		formStrucWeiterArbeitsproben()
	);
};
